/**
 * Timeline Service
 */

import { httpClient } from '../http-client';
import type { TimelineItemData } from './types';

const API_BASE_URL = '/api/v1';

export interface TimelineResponse {
  items: TimelineItemData[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface TimelineStats {
  totalItems: number;
  byType: Record<string, number>;
  recentActivity: {
    lastWeek: number;
    lastMonth: number;
  };
}

export const TimelineService = {
  /**
   */
  async getTimeline(params?: {
    page?: number;
    limit?: number;
    types?: string[];
  }): Promise<TimelineResponse> {
    try {
      const url = `${API_BASE_URL}/timeline`;
      const queryParams: Record<string, string> = {};

      if (params?.page) queryParams.page = params.page.toString();
      if (params?.limit) queryParams.limit = params.limit.toString();
      if (params?.types?.length) queryParams.types = params.types.join(',');

      const response = await httpClient.get<TimelineResponse>(url, { params: queryParams });
      return response.data;
    } catch (error) {
      console.error('Error fetching timeline:', error);
      throw error;
    }
  },

  /**
   */
  async getTimelineStats(): Promise<TimelineStats> {
    try {
      const url = `${API_BASE_URL}/timeline/stats`;
      const response = await httpClient.get<TimelineStats>(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching timeline stats:', error);
      throw error;
    }
  },
};
